import React, { useState, useEffect } from "react";
import NavigationBar from "../../components/NavBar.js";
import Cookies from "js-cookie";

import "../../assets/stylesheets/users.scss";

export default function Waitlist() {
  const [users, setUsers] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const accessToken = Cookies.get("access_token");

    fetch(
      `${process.env.REACT_APP_BACKEND_DOMAIN}/api/admin/users?type=waitlisted`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Cookie: `admin2=${Cookies.get("admin2")}`,
          "X-Auth": `admin2=${Cookies.get("admin2")}`,
        },
      }
    )
      .then((response) => {
        if (response.status === 403) {
          window.location.href = "/login";
        } else if (response.status === 401) {
          window.location.href = "/admin/authenticate";
        } else {
          return response.json(); // Get the user data
        }
      })
      .then((data) => {
        if (data) {
          setUsers(data); // Set user data to the state
        }
      })
      .catch((error) => console.error("Error fetching users:", error));
  }, []);

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  function sendRequest(type, discordID) {
    fetch(`${process.env.REACT_APP_BACKEND_DOMAIN}/api/admin/waitlist/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("access_token")}`,
        Cookie: `admin2=${Cookies.get("admin2")}`,
        "X-Auth": `admin2=${Cookies.get("admin2")}`,
      },
      body: JSON.stringify({ type, discordID }),
    })
      .then((data) => data.json()) // Parse the response data
      .then((data) => {
        if (data.status === 403) {
          window.location.href = "/login";
        } else if (data.status === 401) {
          window.location.href = "/admin/authenticate";
        } else if (data.status === 200) {
          // Find the user with the matching discord ID
          const updatedUsers = users.map((user) => {
            if (user.userID === discordID) {
              // Update the user's status with the one from the response
              return {
                ...user,
                userStatus: data.newStatus, // Assuming the response contains the new status
              };
            }
            return user;
          });

          setUsers(updatedUsers); // Update the state with the updated user data
        } else {
          // Handle error cases
          console.error("Error updating user:", data.error);
        }
      })
      .catch((error) => console.error(`Error ${type}ing:`, error));
  }

  return (
    <div>
      <NavigationBar />

      <div className="users">
        <h2> Waitlist Users </h2>

        <table className="user-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Discord ID</th>
              <th>Stripe ID</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td onClick={() => handleCopyToClipboard(user.name)}>
                  {user.name}
                </td>
                <td onClick={() => handleCopyToClipboard(user.email)}>
                  {user.email}
                </td>
                <td onClick={() => handleCopyToClipboard(user.userID)}>
                  {user.userID}
                </td>
                <td
                  onClick={() =>
                    handleCopyToClipboard(user.billing.customer_id)
                  }
                >
                  {user.billing.customer_id}
                </td>
                <td onClick={() => handleCopyToClipboard(user.userStatus)}>
                  {user.userStatus}
                </td>
                <td>
                  <button
                    className="green"
                    onClick={() => sendRequest("accept", user.userID)}
                  >
                    Approve
                  </button>
                  <button
                    className="red"
                    onClick={() => sendRequest("decline", user.userID)}
                  >
                    Decline
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
